import { GridCellProps } from '@progress/kendo-react-grid';
import { format } from 'date-fns';
import { useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';

const ScannedOnCell = (props: GridCellProps) => {
  const { handleCellClick } = useInvoiceScanManager();

  const field = props.field || '';
  const value = props.dataItem[field];
  const formattedValue = value ? format(new Date(value), props.format) : 'N/A';

  const handleClick = useCallback(() => {
    handleCellClick(props.dataItem.attachId);
  }, [handleCellClick, props.dataItem.attachId]);

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} onClick={handleClick} title={formattedValue}>
      {formattedValue}
    </GridCellBase>
  );
};

export default ScannedOnCell;